import React from "react"

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    FormControlLabel,
    Switch,
    Box,
} from "@mui/material"

import {
    MatesSelect,
    MatesTextField,
    withUseFormHook,
} from "@sinossi/mates-react-library"

import {
    t,
    Trans,
} from "@lingui/macro"
import { UseFormReturn } from "react-hook-form"

import { UseRouterParams } from "services/router"
import { PaginatedResponse } from "models/commons/paginated-response"
import { Company } from "models/company"
import { CreateCompanyForm } from "components/brand/create-company-form"

import CreateBrandValidation from "./form"

interface CreateBrandModalProps extends UseFormReturn, UseRouterParams
{
    closeModal: () => void,
    submitForm: (values: any) => void,
    companyList: PaginatedResponse<Company>,
}
interface CreateBrandModalState
{
    createNewCompany: boolean
}
class CreateBrandModal extends React.Component<CreateBrandModalProps,CreateBrandModalState>
{
    constructor(props: any)
    {
        super(props)
        this.state = {
            createNewCompany: false,
        }
    }

    private submitForm = (values: any) => {
        this.props.submitForm(values)
    }

    private handleToggleCreateCompany = (event: React.ChangeEvent<HTMLInputElement>) => {
        const createNewCompany = event.target.checked
        this.setState({ createNewCompany })
        
        // Aggiorna il valore nel form
        this.props.setValue('createNewCompany', createNewCompany)
        
        // Reset dei campi quando si cambia modalità
        if (createNewCompany) {
            this.props.setValue('company', '')
        } else {
            this.props.setValue('companyData', {})
        }
    }

    render()
    {
        return (
            <>
                <Dialog
                    open={true}
                    onClose={() => this.props.closeModal()}
                    fullWidth
                    maxWidth="md"
                    sx={{
                        '& .MuiPaper-root': {
                            background: '#FEFDF9'
                        },
                        '& .MuiBackdrop-root': {
                            backgroundColor: 'transparent'
                        }
                    }}
                >
                    <DialogTitle>
                        <Typography variant="h5">
                            <Trans id="cbm-modal-title">Aggiungi brand</Trans>
                        </Typography>
                        {/*<Typography >
                            <Trans id="cbm-modal-subtitle">Inserisci i campi per continuare</Trans>
                        </Typography>*/}
                    </DialogTitle>
                    <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                        <DialogContent>
                            <Typography sx={{pt:2, pb:1}}>
                                <Trans id="cbm-name-label">Inserisci il nome</Trans>
                            </Typography>
                            <MatesTextField
                                variant={"outlined"}
                                label={t({
                                    id: "cbm-brand-name",
                                    message: "Nome",
                                })}
                                name="name"
                                control={this.props.control}
                                trigger={this.props.trigger}
                                formState={this.props.formState}
                            />
                            <Box sx={{ mb: 2 }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={this.state.createNewCompany}
                                            onChange={this.handleToggleCreateCompany}
                                            name="createNewCompany"
                                        />
                                    }
                                    label={<Trans id="cbm-create-new-company">Crea nuova società</Trans>}
                                />
                            </Box>

                            {!this.state.createNewCompany ? (
                                <>
                                    <Typography sx={{pb:1}} >
                                        <Trans id="cbm-company-label">Seleziona la società</Trans>
                                    </Typography>
                                    <MatesSelect
                                        variant={"outlined"}
                                        label={t({
                                            id: "cbm-brand-company",
                                            message: "Società",
                                        })}
                                        name="company"
                                        control={this.props.control}
                                        trigger={this.props.trigger}
                                        formState={this.props.formState}
                                    >
                                        {this.props.companyList.items.map((comp) => (
                                            <option value={comp.id} key={comp.id}>{comp.name}</option>
                                        ))}
                                    </MatesSelect>
                                </>
                            ) : (
                                <CreateCompanyForm
                                    {...this.props}
                                />
                            )}
                        </DialogContent>
                        <DialogActions sx={{pr:2}}>
                            <Button onClick={this.props.closeModal}
                                    variant={"contained"}
                                    color="neutral"
                                    sx={{
                                        textTransform: "none",
                                        mr: 1,
                                        width: 100
                                    }}
                                    disableElevation>
                                <Trans id={"cbm-close-button"}>
                                    Annulla
                                </Trans>
                            </Button>
                            <Button type="submit"
                                    variant="contained"
                                    sx={{
                                        backgroundColor: 'secondary.main',
                                        color: 'white',
                                        mr: 1,
                                        textTransform: "none",
                                        width: 100
                                    }}
                            >
                                <Trans id={"fm-confirm-button"}>Conferma</Trans>
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </>
        );
    }

}

export default withUseFormHook<{}>(
    CreateBrandModal,
    CreateBrandValidation,
    {}
)
